<script lang="ts">
    import Avatar from "$lib/components/Avatar.svelte";
    import Toggle from "$lib/components/ui/Toggle.svelte";
    import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
    import Typeahead from "$lib/components/Typeahead.svelte";
    import {
        addAssociateToProject,
        changeProjectAssociateStatus,
        removeAssociateFromProject
    } from "$lib/calls/associate";
    import {getProject} from "$lib/calls/project";
    import AddButton from "$lib/components/ui/AddButton.svelte";
    import UnitAvatar from "$lib/components/UnitAvatar.svelte";
    import {currentUnit} from "$lib/stores/unit";
    import {availableAssociates} from "$lib/stores/customer";
    import {Button} from "flowbite-svelte";
    import {PenSolid} from "flowbite-svelte-icons";

    export let project;
    let newMember;
    let showModify = false;

    let team;
    availableAssociates.subscribe(x => team = x);

    const removeAssociate = async (associate) => {
        try {
            await removeAssociateFromProject(associate, project);
            project = await getProject(project.uuid)
        } catch (e) {
            alert('Fehler beim Entfernen');
        }

    }
    const addAssociate = async () => {
        if (!newMember) {
            return;
        }
        newMember.associateUuid = newMember.uuid;
        try {
            await addAssociateToProject(newMember, project);
            project = await getProject(project.uuid)
            newMember = null
        } catch (e) {
            alert('Fehler beim Hinzufügen');
        }
    }
    const changeAssociateSignatory = async (associate) => {
        try {
            await changeProjectAssociateStatus(associate, project);
            project = await getProject(project.uuid)
        } catch (e) {
            alert('Fehler beim Status ändern');
        }
    }

    const typeAheadData = (team) => {
        return team.filter(x => x.userId !== project.responsibleUserId && !project.associates.map(y => y.associateId).includes(x.id))
    }
    let unit;
    currentUnit.subscribe(val => unit = val)

    console.log(team)
    console.log(project)
</script>
<div >
    <ul class="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2">
        <li>
            <div class="flex items-center gap-x-6">
                <UnitAvatar size="2xl"/>
                <div>
                    <h3 class="text-base font-semibold leading-7 tracking-tight text-gray-900">
                        {unit?.name}
                    </h3>
                    <p class="text-sm font-semibold leading-6 text-primary-600">{unit?.email}</p>

                </div>

            </div>
        </li>
        <li>
            <div class="flex items-center gap-x-6">
                <Avatar bgColor="bg-primary-600" size="2xl"
                        associate={team.find(x => x.userId === project.responsibleAssociate?.userId)}/>
                <div>
                    <h3 class="text-base font-semibold leading-7 tracking-tight text-gray-900">
                        {team.find(x => x.userId === project.responsibleAssociate?.userId)?.name}
                    </h3>
                    <p class="text-sm font-semibold leading-6 text-primary-600">Besteller</p>

                </div>

            </div>
        </li>
        {#if project.associates}
            {#each project.associates as associate}
                <li class="min-h-[110px]">
                    <div class="flex items-center gap-x-6">
                        <Avatar size="2xl" associate={team.find(x => x.id === associate.associateId)}/>
                        <div>
                            <h3 class="text-base font-semibold leading-7 tracking-tight text-gray-900">
                                {team.find(x => x.id === associate.associateId)?.name}
                            </h3>
                            <div class="flex gap-2">
                                <p class="text-sm font-semibold leading-6 text-neutral-600">{team.find(x => x.id === associate.associateId)?.position || 'Teammitglied'}</p>
                                {#if associate.isSignatory && !showModify}
                                    <span class="inline-flex items-center rounded-md bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700">Unterzeichner</span>
                                {/if}
                            </div>

                        </div>
                        {#if showModify}
                            <div>
                                <RemoveButton onClick={() => removeAssociate(associate)}/>
                            </div>
                        {/if}
                    </div>
                    <div class="mt-4">

                        {#if showModify}
                            <Toggle label="Unterzeichner" bind:value={associate.isSignatory}
                                    on:change={() => changeAssociateSignatory(associate)}/>
                        {/if}
                    </div>

                </li>


            {/each}
        {/if}
        {#if showModify}
            <li class="p-4 flex gap-2 items-center max-h-36">
                <Typeahead icon="users-solid" value={newMember?.name} label="Ansprechpartner hinzufügen" data={typeAheadData(team)}
                           extract={selected => newMember = selected}>
                    <svelte:fragment slot="no-results" let:value>
                        <p>"{value}" ergibt keine Treffer. Externe Ansprechpartner müssen erst in Ihrer Organisation
                            eingetragen werden.</p>
                    </svelte:fragment>
                </Typeahead>
                <div class="mt-7">
                    <AddButton onClick="{addAssociate}"/>
                </div>

            </li>
        {/if}
    </ul>
    <div class="grid mt-12">
        <Button color="alternative" size="sm" class="place-self-center flex gap-2 text-primary-400" on:click={() => showModify = !showModify}>
            <PenSolid size="sm" />
            Bearbeiten
        </Button>
    </div>

</div>
